module.exports = __webpack_public_path__ + "media/images/profile/photo-requested-d3ab3b43bbad50ee91138ed080ed5baf.svg";